export default "__VITE_ASSET__pZM1PBeC__"